<template>

  <div class="corpo-pagina">

    <div class="row row-text">
      <div class="col s12">
        <h4>{{ this.translation.getters.traduzione('btn.login') }}</h4>
      </div>
    </div>

    <div class="divider"></div>

    <div class="row">
      <div class="col s12 m7 l7">
        <form class="col s12 filed-box">
          <div>
            <div class="input-field">
              <i class="material-icons prefix">email</i>
              <input type="text" v-model="form.username" class="validate" id="username" autocomplete="off">
              <label for="username">{{ this.translation.getters.traduzione('field.account.email') }}</label>
              <span id="error-message-username" class="error-message-style nodipslay">
                  {{ this.translation.getters.traduzione('filed.required.validation') }}
              </span>
            </div>
          </div>
        </form>
      </div>
      <div class="col s12 m5 l5"></div>
    </div>

    <div class="row">
      <div class="col s12 m7 l7">
        <form class="col s12 filed-box">
          <div>
            <div class="input-field">
              <i class="material-icons prefix">vpn_key</i>
              <input type="password" v-model="form.password" class="validate" id="password" autocomplete="off">
              <label for="password">{{ this.translation.getters.traduzione('filed.password') }}</label>
              <span class="password-toggle" id="pwd-tog">
                 <i class="material-icons" @click="showPassword1 = !showPassword1">{{ showPassword1 ? 'visibility_off' : 'visibility' }}</i>
              </span>
              <span id="error-message-password" class="error-message-style nodipslay">
                  {{ this.translation.getters.traduzione('filed.required.validation') }}
              </span>
            </div>
          </div>
        </form>
      </div>
      <div class="col s12 m5 l5"></div>
    </div>

    <div class="row">
      <div class="col s12 m12 l12">
        <form class="col s12 filed-box">
          <label>
            <input type="checkbox" class="" v-model="form.rememberme" value="" id="rememberme">
            <span>{{ this.translation.getters.traduzione('checkbox.remeber.me') }}</span>
          </label>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col s12 m4 l4">
        <span id="credencial-error" class="error-message-style nodipslay" style="font-size: 20px!important;">
                  {{ this.translation.getters.traduzione('credencials.error') }}
        </span>
      </div>
      <div class="col s12 m8 l8"></div>
    </div>

    <div class="row row-text">
      <div class="col s12">
        <p><a href="/recover-password" class="link-igotu">{{ this.translation.getters.traduzione('forgot.passwor.ask') }}</a></p>
      </div>
    </div>

    <div class="row">
    <div class="col s12 m4 l4">
      <RecaptchaWidget ref="captcha" />
    </div>
  </div>

    <div class="row">
      <div class="col s12 m4 l4">

        <a class="btn-large" @click="login()">
          <i class="material-icons left">security</i>
          {{ this.translation.getters.traduzione('btn.login') }}
        </a>
      </div>
      <div class="col s12 m8 l8"></div>
    </div>

  </div>

</template>
<script>

import apiService from '@/services/apiService.js'
import translationStore from '@/store/translations'
import useAuthStore from '@/store/authStore.js'
import loadingStore from '@/store/loading'
import RecaptchaWidget from '@/components/RecaptchaWidget.vue'

export default {
  components: { RecaptchaWidget },
  data () {
    return {
      form: { username: '', password: '', rememberme: false },
      translation: translationStore,
      msg: false,
      showPassword1: false

    }
  },
  methods: {

    async validateForm () {
      const allElements = document.querySelectorAll('*') // Seleziona tutti gli elementi nel DOM
      const msgElements = document.querySelectorAll('.error-message-style')
      let res = true

      allElements.forEach(element => {
        if (element.classList.contains('invalid')) {
          element.classList.remove('invalid')
        }
        if (element.classList.contains('invalid-icon')) {
          element.classList.remove('invalid-icon')
        }
      })

      msgElements.forEach(element => {
        element.classList.add('nodipslay')
      })

      const us = document.getElementById('username')
      const pw = document.getElementById('password')
      const usErro = this.$validateEmail(us.value)
      const pwErro = this.$validatePassword(pw.value)

      if (!usErro) {
        us.classList.add('invalid')
        const prefixIcon = us.previousElementSibling
        if (prefixIcon && prefixIcon.classList.contains('prefix')) {
          prefixIcon.classList.add('invalid-icon')
        }
        const msg = document.getElementById('error-message-username')
        if (msg) {
          msg.classList.remove('nodipslay')
        }
        res = false
      }

      if (!pwErro) {
        pw.classList.add('invalid')
        const prefixIcona = pw.previousElementSibling
        if (prefixIcona && prefixIcona.classList.contains('prefix')) {
          prefixIcona.classList.add('invalid-icon')
        }

        const msga = document.getElementById('error-message-password')
        if (msga) {
          msga.classList.remove('nodipslay')
        }
        res = false
      }
      return res
    },

    finishLogin () {
      const params = new URLSearchParams(window.location.search)
      const tk = params.get('success')

      if (tk) {
        // M.toast({ html: this.translation.getters.traduzione('frase.password.commplete') })
      }
    },

    async login () {
      loadingStore.commit('setLoading', true)

      const tokenTobot = this.$refs.captcha.getToken()
      if (!tokenTobot) {
        alert('Per favore conferma che non sei un robot!')
        loadingStore.commit('setLoading', false)
        return
      }

      const valid = await this.validateForm()

      if (valid) {
        try {
          const token = await apiService.getClientCredentialsToken()
          if (!token) {
            this.$router.push('/error')
          } else {
            const tokenLogin = await apiService.getLoginUserToken(token, this.form)

            if (!tokenLogin) {
              this.validateForm()

              const us = document.getElementById('username')
              const pw = document.getElementById('password')

              us.classList.add('invalid')
              const prefixIcon = us.previousElementSibling
              if (prefixIcon && prefixIcon.classList.contains('prefix')) {
                prefixIcon.classList.add('invalid-icon')
              }

              pw.classList.add('invalid')
              const prefixIcona = pw.previousElementSibling
              if (prefixIcona && prefixIcona.classList.contains('prefix')) {
                prefixIcona.classList.add('invalid-icon')
              }

              const msg = document.getElementById('credencial-error')
              if (msg) {
                msg.classList.remove('nodipslay')
              }
            } else {
              useAuthStore.dispatch('authenticate', tokenLogin.userinfo)
              this.$router.push('/list-events')
              window.location.reload()
            }
          }
        } catch (error) {
          this.$router.push('/error')
        }
      }
      loadingStore.commit('setLoading', false)
    }
  },

  mounted () {
    this.$nextTick(() => {
      const passwordInput = document.getElementById('password')
      const passwordToggle = document.getElementById('pwd-tog')
      if (passwordToggle) {
        passwordToggle.addEventListener('click', function () {
          const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password'
          passwordInput.setAttribute('type', type)
          this.querySelector('i').textContent = type === 'password' ? 'visibility' : 'visibility_off'
        })
      }
    })

    this.finishLogin()
    loadingStore.commit('setLoading', false)
  }

}
</script>
<style>
.input-field {
  position: relative;
  /* Rende il contenitore un punto di riferimento per il posizionamento assoluto */
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 10px;
  /* Regola la distanza dal bordo destro */
  transform: translateY(-50%);
  /* Centra verticalmente l'icona */
  cursor: pointer;
  /* Indica che è cliccabile */
  user-select: none;
  /* Impedisce la selezione del testo dell'icona */
}

.password-toggle i {
  color: #757575;
  /* Colore dell'icona (grigio medio) */
}
</style>
